import { get } from "@insite/client-framework/Services/ApiService";
import { CuttingToolModel } from "@theStellarBlueprint/CustomApiModel";

const cuttingToolConfiguratorUrl = "/api/v2/CuttingToolConfigurator";

export function getCuttingTool() {
    return get<CuttingToolModel>(`${cuttingToolConfiguratorUrl}`);
}
